import React from 'react';
import styles from './RegionalFreePeriodBanner.module.scss';

const RegionalFreePeriodLookupLoading = () => (
    <section className={styles.banner} role="status" aria-live="polite">
        <span className={styles.loadingIcon} aria-hidden="true">…</span>
        <div>
            <p className={styles.title}>Confirming regional placement pricing</p>
            <p className={styles.message}>Checking this office and shift date…</p>
        </div>
    </section>
);

export default RegionalFreePeriodLookupLoading;
